import { useLayoutEffect, useRef, useState } from 'react';

const useTablePagination = ({
  initialPage = 0,
  initialPageSize,
  rowsPerPageOptions,
  resetKey,
  skipReset = false,
}) => {
  const [page, setPage] = useState(initialPage || 0);
  const [pageSize, setPageSize] = useState(
    initialPageSize || rowsPerPageOptions?.[0] || 25,
  );
  const isFirstResetKey = useRef(true);

  useLayoutEffect(() => {
    if (skipReset) {
      return;
    }
    if (isFirstResetKey.current) {
      isFirstResetKey.current = false;
      return;
    }
    setPage(0);
  }, [resetKey, skipReset]);

  return {
    page,
    setPage,
    pageSize,
    setPageSize,
  };
};

export default useTablePagination;
